import { Icon, IconProps } from "../Icon";

const Collection = (props: IconProps) => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31 15H29V3H17V1H29C30.1046 1 31 1.89543 31 3V15ZM24 22H26V8C26 6.89543 25.1046 6 24 6H10V8H24V22ZM4 30H18C19.1046 30 20 29.1046 20 28V14C20 12.8954 19.1046 12 18 12H4C2.89543 12 2 12.8954 2 14V28C2 29.1046 2.89543 30 4 30ZM4 28V14H18V28H4Z"
      fill="currentColor"
    />
  </Icon>
);

export default Collection;
